"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformNetConnection = void 0;
const TransformObject_1 = require("./TransformObject");
const TransformSchematicDrawing_1 = require("./TransformSchematicDrawing");
class TransformNetConnection extends TransformObject_1.TransformObject {
    constructor(parent, data) {
        if (!parent) {
            throw new Error('TransformNetConnection must have a parent');
        }
        super(parent, {
            position: data.position,
            moduleRef: data.moduleRef,
            moduleName: data.moduleName,
            pinRef: data.pinRef,
            pinNumber: data.pinNumber,
            pinPosition: data.pinPosition,
            appliesNetName: data.appliesNetName,
            skipPositionalCombobulation: data.skipPositionalCombobulation,
            debugDrawings: [],
        }, undefined, new Set());
        const debugLayer = this.context?.options?.combobulationDebugLayerId;
        if (debugLayer !== undefined) {
            const label = data.appliesNetName ?
                `${data.moduleName}.${data.pinRef}[=${data.appliesNetName.label}]`
                : `${data.moduleName}.${data.pinRef}`;
            this._sharedData.debugDrawings.push(new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [debugLayer],
                drawing: { type: 'junction', position: data.position, radiusOverride: 0.75 },
            }), new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [debugLayer],
                drawing: {
                    type: 'text',
                    value: label,
                    pos: [data.position[0] + 0.5, data.position[1]],
                    angle: 90,
                    justify: [-1, -1],
                    size: 1,
                    thickness: 1,
                },
            }));
        }
    }
    get creates() {
        return this._sharedData.debugDrawings;
    }
    compile() {
        const result = this.parent.netCombobulator.addConnection(this._sharedData.position, {
            moduleRef: this._sharedData.moduleRef,
            moduleName: this._sharedData.moduleName,
            pinRef: this._sharedData.pinRef,
            pinNumber: this._sharedData.pinNumber,
            pinPosition: this._sharedData.pinPosition,
            appliesNetName: this._sharedData.appliesNetName,
            skipPositionalCombobulation: this._sharedData.skipPositionalCombobulation,
        });
        return result;
    }
}
exports.TransformNetConnection = TransformNetConnection;
//# sourceMappingURL=TransformNetConnection.js.map